import { copApi } from 'api'

export interface JobFamily {
  id: string
  name: string
}
export const fetchJobFamily = () => copApi.get<JobFamily[]>('/job-family-groups')
